// extracted by mini-css-extract-plugin
export default {"panesliderOverlay":"style_panesliderOverlay__ybjc8","panelSlide":"style_panelSlide__2Yv-Q","closebtn":"style_closebtn__+8BR7","open":"style_open__ao38H","close":"style_close__k6L97"};